export const stopWords = new Set([
	'a',
	'an',
	'the',
	'are',
	'am',
	'was',
	'were',
	'be',
	'been',
	'being',
	'and',
	'or',
	'but',
	'in',
	'on',
	'at',
	'to',
	'for',
	'of',
	'with',
	'by',
	'from',
	'as',
	'if',
	'this',
	'that',
	'these',
	'those',
	'i',
	'you',
	'he',
	'she',
	'it',
	'we',
	'they',
]);
